import React from "react";
import CheckBoxWithLabel from "../checkbox/CheckBoxWithLabel";
import CustomRadioButton from "../buttons/CustomRadioButton";
import CustomDatePicker from "../DatePicker/CustomDatePicker";
import { breadcrumbsContent } from "../breadcrumbs/BreadcrumbsContent";
import useTranslation from "../CustomHooks/useTranslation";
import dayjs from "dayjs";

interface DynamicFilterProps {
  dynamicFilter: {
    [key: string]: { mapItem: string[]; type: string; default?: string };
  };
  leftSide?: boolean; 
  rightSide?: boolean;
  activeFilter?: string;
  onFilterChange?: (filterKey: string) => void;
  onDynamicFilterChange?: (
    filterKey: string,
    value: string | dayjs.Dayjs | null,
    type: string
  ) => void;
  dynamicFilterValue?: { [key: string]: string | string[] };
  startDate?: dayjs.Dayjs | null;
  endDate?: dayjs.Dayjs | null;
  handleDateChange: (date: dayjs.Dayjs | null, type: string) => void;
  errorMessage: string;
}

const DynamicFilter: React.FC<DynamicFilterProps> = ({
  dynamicFilter,
  leftSide,
  rightSide,
  activeFilter,
  onFilterChange,
  onDynamicFilterChange,
  dynamicFilterValue,
  startDate,
  endDate,
  handleDateChange,
  errorMessage
}) => {
  const { translate, notEnglish } = useTranslation(breadcrumbsContent);
  const handelCheckBox = (id: string) => {
    onDynamicFilterChange?.(activeFilter || "", id, "checkbox");
  };
  const handleRadioChange = (value: string) => {
    onDynamicFilterChange?.(activeFilter || "", value, "radio");
  };
  const preventCloseOnDatePickerClick = (event: React.MouseEvent) => {
    event.stopPropagation();
  };


  return (
    <>
      {leftSide &&
        Object.entries(dynamicFilter).map(([key, value]) => (
          <p
            key={key}
            data-testid={`filter-${key}`}
            className={`pb-3 pr-3 cursor-pointer text-title1 ${activeFilter === key ? "text-primary_text" : "text-secondary_text"
              }`}
            onClick={() => onFilterChange?.(key)}
          >
            {key}
          </p>
        ))}
      {rightSide && dynamicFilter[activeFilter || ""]?.type === "checkbox" && (
        <div>
          {dynamicFilter[activeFilter || ""]?.mapItem.map(
            (item: string, index: number) => (
              <CheckBoxWithLabel
                key={index}
                label={item}
                handelCheckBox={handelCheckBox}
                checked={
                  Array.isArray(dynamicFilterValue?.[activeFilter || ""])
                    ? dynamicFilterValue?.[activeFilter || ""]?.includes(item)
                    : false
                }
                id={item}
              />
            )
          )}
        </div>
      )}
      {rightSide && dynamicFilter[activeFilter || ""]?.type === "date" && (
        <div>
          <div
            className="flex justify-between gap-3"
            onMouseDown={preventCloseOnDatePickerClick}
          >
            <CustomDatePicker
              testID="start-date"
              label={translate("Start Date")}
              handleStates={handleDateChange}
              value={startDate ? startDate : null}
              error={
                errorMessage === "Please select start date"
                  ? "Please select start date"
                  : ""
              }
              disabled={false}
              fieldError={!!errorMessage}
              type="requested_start"
              required
              classType={"filter"}
            />
            <CustomDatePicker
              testID="end-date"
              label={translate("End Date")}
              handleStates={handleDateChange}
              value={endDate ? endDate : null}
              required
              error={
                errorMessage === "Please select end date"
                  ? "Please select end date"
                  : ""
              }
              disabled={false}
              fieldError={!!errorMessage}
              type="requested_end"
              classType={"filter"}
            />
          </div>
        </div>
      )}
      {rightSide && dynamicFilter[activeFilter || ""]?.type === "radio" && (
        <div>
          <CustomRadioButton
            selected={
              typeof dynamicFilterValue?.[activeFilter || ""] === "string"
                ? (dynamicFilterValue?.[activeFilter || ""] as string)
                : dynamicFilter[activeFilter || ""]?.default || ""
            }
            options={dynamicFilter[activeFilter || ""]?.mapItem.map(
              (item: string) => ({
                id: item.toLowerCase(),
                label: item,
                testID: item,
              })
            )}
            onChange={handleRadioChange}
          />
        </div>
      )}
    </>
  );
};

export default DynamicFilter;
